import { useCallback, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../../hooks';
import { isBrowser } from '../../utils';
let ResizeObserver;
if (isBrowser()) {
  if (window.ResizeObserver) {
    ResizeObserver = window.ResizeObserver;
  } else {
    import('resize-observer-polyfill').then(module => {
      ResizeObserver = module.default;
    });
  }
}
export const useResizeObserver = (ref, callback) => {
  const callbackRef = useRef(callback);
  const handleResize = useCallback(entries => {
    if (!Array.isArray(entries)) return;
    callbackRef.current == null ? void 0 : callbackRef.current(entries[0].contentRect);
  }, [callbackRef]);
  useIsomorphicLayoutEffect(() => {
    var _observer;
    let observer = ResizeObserver ? new ResizeObserver(entries => handleResize(entries)) : null;
    if (ref.current) (_observer = observer) == null ? void 0 : _observer.observe(ref.current);
    return () => {
      var _observer2;
      (_observer2 = observer) == null ? void 0 : _observer2.disconnect();
      observer = null;
    };
  }, [ref, handleResize, ResizeObserver]);
};